"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.link = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var link = function link(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'link-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M8.99238 13.6896L8.76256 13.9194C7.2981 15.3839 4.92373 15.3839 3.45926 13.9194C1.9948 12.455 1.9948 10.0806 3.45926 8.61612L6.28769 5.7877C7.57054 4.50485 9.55159 4.34575 11.0076 5.31041L11.2374 5.08059C12.7019 3.61612 15.0763 3.61612 16.5407 5.08059C18.0052 6.54505 18.0052 8.91942 16.5407 10.3839L13.7123 13.2123C12.4295 14.4952 10.4484 14.6543 8.99238 13.6896ZM9.47065 12.1526C10.3494 13.0303 11.7733 13.03 12.6516 12.1517L15.4801 9.32323C16.3588 8.44455 16.3588 7.01993 15.4801 6.14125C14.6014 5.26257 13.1768 5.26257 12.2981 6.14125L12.0683 6.37107C13.0329 7.82709 12.8738 9.80815 11.591 11.091L10.8839 11.7981C10.591 12.091 10.1161 12.091 9.82322 11.7981C9.53033 11.5052 9.53033 11.0303 9.82322 10.7374L10.5303 10.0303C11.409 9.15166 11.409 7.72704 10.5303 6.84836C10.5301 6.84812 10.5299 6.84789 10.5296 6.84766C9.6509 5.96968 8.2268 5.96991 7.34835 6.84836L4.51992 9.67678C3.64124 10.5555 3.64124 11.9801 4.51992 12.8588C5.3986 13.7374 6.82323 13.7374 7.7019 12.8588L7.93172 12.6289C6.96707 11.1729 7.12616 9.19186 8.40901 7.90902L9.11612 7.20191C9.40901 6.90902 9.88388 6.90902 10.1768 7.20191C10.4697 7.4948 10.4697 7.96968 10.1768 8.26257L9.46967 8.96968C8.59099 9.84835 8.59099 11.273 9.46967 12.1517C9.47 12.152 9.47033 12.1523 9.47065 12.1526Z',
    fill: '#4B5563'
  }));
};

exports.link = link;